var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 0L4.19995 10.8H17.4L10.8 0ZM17.4 24C18.1091 24 18.8113 23.8603 19.4664 23.5889C20.1216 23.3176 20.7169 22.9198 21.2183 22.4184C21.7198 21.9169 22.1175 21.3217 22.3889 20.6665C22.6603 20.0113 22.8 19.3091 22.8 18.6C22.8 17.8909 22.6603 17.1887 22.3889 16.5335C22.1175 15.8784 21.7198 15.2831 21.2183 14.7816C20.7169 14.2802 20.1216 13.8824 19.4664 13.6111C18.8113 13.3397 18.1091 13.2 17.4 13.2C15.9678 13.2 14.5943 13.7689 13.5816 14.7816C12.5689 15.7943 12 17.1678 12 18.6C12 20.0322 12.5689 21.4057 13.5816 22.4184C14.5943 23.4311 15.9678 24 17.4 24ZM-4.57764e-05 13.8H9.59995V23.4H-4.57764e-05V13.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCategory);
export default __webpack_public_path__ + "static/media/ic_category.cd3b79c4a1d3357b043fb6ddab346626.svg";
export { ForwardRef as ReactComponent };